import _asyncToGenerator from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TabelToolBar from './component/TabelToolBar.vue';
import { SaveData, LoadData, SendEmail } from '@/api/SendMail';
import util from '@/libs/util';
import srmDialog from '@/components/srm-dialog';
export default {
  components: {
    TabelToolBar: TabelToolBar,
    srmDialog: srmDialog
  },
  mounted: function mounted() {
    this.getMailData();
  },
  data: function data() {
    var checkNumber = function checkNumber(rule, value, cb) {
      var numberReg = /^(([1-9][0-9]*)|(([0]\.\d{0,4}|[1-9][0-9]*\.\d{0,4})))$/;

      if (numberReg.test(value)) {
        return cb();
      }

      cb(new Error('请输入数字'));
    };

    var checkEmail = function checkEmail(rule, value, cb) {
      var reg = /^([a-zA-Z0-9]+[-_\.]?)+@[a-zA-Z0-9]+\.[a-z]+$/;

      if (!reg.test(value)) {
        cb(new Error('请输入正确的邮箱'));
      } else {
        cb();
      }
    };

    return {
      form: {
        SERVER_ADDR: null,
        SERVER_PORT: null,
        EMAIL_USER: null,
        EMAIL_AUTH_CODE: null,
        ENABLE_SSL: 0
      },
      isHasInfo: false,
      Rules: {
        SERVER_ADDR: [{
          required: true,
          message: '请输入服务器地址',
          trigger: 'blur'
        }],
        SERVER_PORT: [{
          required: true,
          message: '请输入服务器端口',
          trigger: 'blur'
        }, {
          validator: checkNumber,
          trigger: ['change', 'blur']
        }],
        EMAIL_USER: [{
          required: true,
          message: '请输入邮箱地址',
          trigger: 'blur'
        }, {
          validator: checkEmail,
          trigger: ['change', 'blur']
        }],
        EMAIL_AUTH_CODE: [{
          required: true,
          message: '请输入邮箱授权码',
          trigger: 'blur'
        }]
      },
      isDisable: true,
      currentType: 'list',
      sendDialogVisible: false,
      testForm: {
        MailTitle: null,
        Recipient: null,
        MailBody: null,
        ORGANIZE_ID: util.cookies.get('ORG_ID')
      },
      loading: false
    };
  },
  methods: {
    // dialog确定
    handelDialogSubmit: function handelDialogSubmit() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var formdata, res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                formdata = new FormData();
                Object.keys(_this.testForm).forEach(function (i) {
                  formdata.append(i, _this.testForm[i]);
                });
                _this.loading = true;
                _context.next = 5;
                return SendEmail(formdata);

              case 5:
                res = _context.sent;
                _this.loading = false; // console.log(res);

                if (res.code === 0) {
                  _this.$message.success('测试邮件发送成功');

                  _this.sendDialogVisible = false;

                  _this.$refs.testForm.resetFields();
                } else {
                  _this.$message.warning(res.message);
                }

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    // dialog取消
    handelClose: function handelClose() {
      this.sendDialogVisible = false;
    },
    handelEmailTest: function handelEmailTest() {
      this.sendDialogVisible = true;
    },
    handleSaveOrder: function handleSaveOrder() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this2.$refs.form.validate( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(vali) {
                    var params, res;
                    return regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            if (!(vali === true)) {
                              _context2.next = 7;
                              break;
                            }

                            params = {
                              SERVER_ADDR: _this2.form.SERVER_ADDR,
                              SERVER_PORT: _this2.form.SERVER_PORT,
                              EMAIL_USER: _this2.form.EMAIL_USER,
                              EMAIL_AUTH_CODE: _this2.form.EMAIL_AUTH_CODE,
                              ENABLE_SSL: _this2.form.ENABLE_SSL,
                              ORGANIZE_ID: util.cookies.get('ORG_ID')
                            };
                            _context2.next = 4;
                            return SaveData(params);

                          case 4:
                            res = _context2.sent;
                            console.log(res);

                            if (res.code === 0) {
                              _this2.$message.success('保存邮件配置成功');

                              _this2.isDisable = true;
                              _this2.currentType = 'list';

                              _this2.getMailData();
                            }

                          case 7:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    handleCancelBtn: function handleCancelBtn() {
      this.isDisable = true;
      this.currentType = 'list';
      this.$refs.form.clearValidate();
      this.getMailData();
    },
    handelAddBtn: function handelAddBtn() {
      this.isDisable = false;
      this.currentType = 'edit';
    },
    getMailData: function getMailData() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var params, res;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                params = {
                  ORGANIZE_ID: util.cookies.get('ORG_ID')
                };
                _context4.next = 3;
                return LoadData(params);

              case 3:
                res = _context4.sent;
                console.log('邮件配置 res', res);

                if (res.code === 0) {
                  if (res.data.length > 0) {
                    _this3.form.SERVER_ADDR = res.data[0].SERVER_ADDR;
                    _this3.form.SERVER_PORT = res.data[0].SERVER_PORT;
                    _this3.form.EMAIL_USER = res.data[0].EMAIL_USER;
                    _this3.form.EMAIL_AUTH_CODE = res.data[0].EMAIL_AUTH_CODE;
                    _this3.form.ENABLE_SSL = res.data[0].ENABLE_SSL;
                    _this3.isHasInfo = true;
                  } else {
                    _this3.isHasInfo = false;
                  }
                }

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    }
  }
};